module.exports =
  '_ERROR_HANDLER':
    'UNEXPECTED_ERROR_MSG': '予期せぬエラーが発生しました。ご不便をおかけして申し訳ございません。しばらくしてから再度お試し下さい。'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/error-handler/i18n/ja.coffee